import { useDisclosure } from '@chakra-ui/react'
import { useCallback, useMemo } from 'react'

import { RPCRefresh } from '@/client/rpc'
import getSeriesFeedbackTutorFormInputs from '@/client/services/formInputs/getSeriesFeedbackTutorFormInputs'

import Form from '@/components/UI/Form/Form'
import type { FormValues } from '@/components/UI/Form/types'
import ModalV3 from '@/components/UI/Modal/ModalV3'

export default function SeriesFeedbackModalTutor({
  seriesId,
  seriesTitle,
}: {
  seriesId: number
  seriesTitle: string
}): JSX.Element {
  const { isOpen, onClose } = useDisclosure({
    defaultIsOpen: true,
  })

  const formInputs = useMemo(() => getSeriesFeedbackTutorFormInputs(seriesTitle), [seriesTitle])

  const handleSubmit = useCallback(
    async (values: FormValues) => {
      await RPCRefresh.submitSeriesTutorFeedback({
        seriesId,
        npsRating: Number.parseInt(`${values.tutor_nps_rating}`, 10),
        comment: `${values.comment}`,
      })
    },
    [seriesId]
  )

  return (
    <ModalV3
      onClose={onClose}
      open={isOpen}
      key={`series-feedback-tutor-${seriesId}`}
      disableClickOutside
      disableClose
      title="Share your feedback!"
      body={() => (
        <Form name="SeriesFeedbackModalTutor" blocks={formInputs} onSubmit={handleSubmit} />
      )}
    />
  )
}
